export const REFERRAL_COOKIE_NAME = "venturous_ref";
